import Vue from "vue";
import VueRouter from "vue-router";
import Nutech from "../views/Nutech.vue";
import ClientOne from "../views/ClientOne";
import ClientTwo from "../views/ClientTwo";
import FeedBack from "../views/FeedBack";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "nutech",
    component: Nutech
  },
  {
    path: "/asigncard",
    name: "clientone",
    component: ClientOne
  },
  {
    path: "/configuration",
    name: "clienttwo",
    component: ClientTwo
  },
  {
    path: "/feedback",
    name: "feedback",
    component: FeedBack
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
